const AbstractPayyoRequestRecord = require('./AbstractPayyoRequestRecord');

/**
 * Fetch an array of all the devices assigned to a merchant.
 */
class PayyoDeviceListRequestRecord extends AbstractPayyoRequestRecord {
    /**
     * A merchantId is a 35 character string beginning with mr_ which identifies a merchant in Payyo.
     *
     * @param {string} merchantId
     */
    constructor(merchantId) {
        const regex = /^mr_[a-zA-Z0-9]{32}$/g;
        if (!regex.test(merchantId)) {
            throw new Error('A valid merchantId is required');
        }

        super(
            'GET',
            'merchants/' + merchantId + '/devices',
        );
    }
}

module.exports = PayyoDeviceListRequestRecord;
